export const statusTypeLabelMap = {
  productionAccepted: 'DeveloperTools.AcceptItem',
  fulfillerRejected: 'DeveloperTools.RejectItemStatus',
  fulfillment: 'DeveloperTools.Ship',
  nothingCancelled: 'DeveloperTools.CouldNotCancel',
  productionStarted: 'DeveloperTools.SendToProduction',
  cancellationResponse: 'DeveloperTools.ConfirmCancellation',
};
